
const digest = '13c958d53a8a91049340099912cbba64fd32972e397036076ce92b2c24f9a258';
const classes = {"topContent":"_topContent_1hsi5_1","required":"_required_1hsi5_7"};
const css = `._topContent_1hsi5_1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

._required_1hsi5_7 {
  font-family: Poppins, sans-serif;
  display: inline-block;
  font-size: 10px !important;
  font-weight: 500 !important;
  text-transform: uppercase;
  color: #212357 !important;
  padding-right: 20px !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  